export default __webpack_public_path__ + "static/orderingTerminalAppsVp5-223e4f97c0a2dc5fe74b8d453784aa52.jpeg";